import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import './LandingPage.scss'
import { useGetAppStatusQuery } from '../../store/api/appStatusApi'

const LandingPage = () => {
  const navigate = useNavigate()
  const { data: appStatus } = useGetAppStatusQuery()

  const sushiDisabled = appStatus?.isSushiDisabled ?? false
  const cateringDisabled = appStatus?.isCateringDisabled ?? false

  useEffect(() => {
    if (!appStatus) return
    if (appStatus.isSushiDisabled && !appStatus.isCateringDisabled) {
      navigate('/catering', { replace: true })
    } else if (appStatus.isCateringDisabled && !appStatus.isSushiDisabled) {
      navigate('/sushi', { replace: true })
    }
  }, [appStatus])

  return (
    <div className='landing-page'>
      <div className='landing-page__options'>
        <div
          className={`landing-page__option landing-page__option--sushi${
            sushiDisabled ? ' disabled' : ''
          }`}
          onClick={() => !sushiDisabled && navigate('/sushi')}
        >
          <div className='landing-page__option-content'>
            <img
              src='/logo_bg.png'
              alt='Panda Sushi'
              className='landing-page__option-logo'
            />
            {sushiDisabled && (
              <p className='landing-page__option-notice'>
                Momentan indisponibil
              </p>
            )}
          </div>
        </div>
        <div
          className={`landing-page__option landing-page__option--catering${
            cateringDisabled ? ' disabled' : ''
          }`}
          onClick={() => !cateringDisabled && navigate('/catering')}
        >
          <div className='landing-page__option-content'>
            <img
              src='/panda-catering-logo-bamboo.png'
              alt='Panda Catering'
              className='landing-page__option-logo'
            />
            {cateringDisabled && (
              <p className='landing-page__option-notice'>
                Momentan indisponibil
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default LandingPage
